const elementIDs = {
  formSelectID: 'form-select-view',
  profileSettingsBackID: 'profile-settingsBack-button',
  studyComingSoonLabelID: 'study-comingSoon-label',
  timeFieldPickerButtonID: 'form-timeFieldPicker-button',
  timeFieldPickerLabelID: 'form-timeFieldPicker-label',
  qualificationCompleteScreenButtonID: 'qualificationComplete-screen-button',
  studyIntroStudySignUpButtonID: 'studyIntro-studySignUp-button',
  studyIntroShareIconID: 'studyIntro-share-icon',
  studyIntroFavoriteIconID: 'studyIntro-favorite-icon',
  studyIntroBackButtonID: 'studyIntro-back-button',
  todayStudyNameID: 'today-study-title',
  profileButtonID: 'navBar-profile-button',
  messageButtonID: 'navBar-message-button',
  chatListItemID: 'chat-list-item',
  chatTextFieldID: 'chat-message-textfield',
  chatSendButtonID: 'chat-send-button',
  confirmDialogYesID: 'confirmDialog-yes-button',
  confirmDialogNoID: 'confirmDialog-no-button',
  encouragementEmojiID: 'component-encouragement-label',
  timeSelectorID: 'form-time-selector',
  timePickerSelectedID: 'form-time-selected',
  confirmButtonID: 'form-timeConfirm-button',
  earnTabID: 'rewards-earnTab-button',
  redeemTabID: 'rewards-redeemTab-button',
  activeTabID: 'studies-activeTab-button',
  pastTabID: 'studies-pastTab-button',
  favoritesTabID: 'studies-favoritesTab-button',
  joinTabID: 'join-joinTab-button',
  createTabID: 'join-createTab-button',
  loadingID: 'form-loading-graphic',
  pointsContainerID: 'navBar-points-button',
  progressionButtonID: 'form-progression-button',
  dateID: 'form-date-selector',
  iosDateSaveID: 'form-dateSave-button',
  iosDateCancelID: 'form-dateCancel-button',
  selectorID: 'form-select-selector',
  textfieldID: 'form-form-textfield',
  numberfieldID: 'form-form-numberfield',
  statefieldID: 'form-state-field',
  biologicalSexfieldID: 'form-biologicalSex-field',
  phoneNumberfieldID: 'form-phoneNumber-field',
  phoneNumberDropdownID: 'form-phoneNumber-dropdown',
  phoneNumberDialogConfirmID: 'form-phoneNumberDialog-confirmButton',
  phoneNumberDialogCancelID: 'form-phoneNumberDialog-cancelButton',
  phoneNumberTextMessageID: 'form-phoneNumber-textMessageBox',
  phoneNumberStudyNotificationID: 'form-phoneNumber-studyNotificationBox',
  datefieldID: 'form-form-datefield',
  formNoteButtonID: 'form-addNote-button',
  formNoteFieldID: 'form-note-field',
  sectionTitleID: 'form-section-title',
  sectionDescriptionID: 'form-section-description',
  elementQuestionID: 'form-element-question',
  elementQuestionTitleID: 'form-element-questionTitle',
  elementQuestionDescriptionID: 'form-element-questionDescription',
  formHtmlID: 'form-html-view',
  formFileID: 'form-filePlugin-view',
  studyIntroHeaderTitleID: 'study-intro-headerTitle',
  studyIntroTitleID: 'study-intro-title',
  studyIntroDurationID: 'study-intro-duration',
  studyIntroOrganizationID: 'study-intro-organization',
  multiOtherFieldID: 'form-multi-otherField',
  timeID: 'form-time-selector',
  numberPickerID: 'form-number-picker',
  sliderID: 'form-slider-selector',
  sliderThumbID: 'form-slider-thumb',
  formWearableTextfieldID: 'form-wearable-textfield',
  todayButtonID: 'navBar-today-button',
  joinButtonID: 'navBar-join-button',
  rewardsButtonID: 'navBar-rewards-button',
  myDataButtonID: 'navBar-myData-button',
  myStudiesButtonID: 'navBar-myStudies-button',
  startCreatingButtonID: 'join-startCreating-button',
  forgotPasswordEmailFieldID: 'forgotPassword-email-textfield',
  continueButtonID: 'forgotPassword-continue-button',
  forgotPasswordReturnButtonID: 'forgotPassword-return-button',
  forgotPasswordTitleID: 'forgotPassword-forgotPassword-title',
  loginEmailID: 'login-email-textfield',
  loginPasswordID: 'login-password-textfield',
  loginButtonID: 'login-login-button',
  loginForgotPasswordID: 'login-forgotPassword-button',
  loginSignUpButtonID: 'login-signUp-button',
  loginWelcomeID: 'login-welcome-title',
  errorLabelID: 'login-error-label',
  resendButtonID: 'emailSent-resend-button',
  tryAnotherEmailID: 'emailSent-tryAgain-button',
  emailSentReturnButtonID: 'emailSent-return-button',
  emailVerificationLabelID: 'signUp-emailVerification-label',
  emailVerificationReturnLinkID: 'signUp-emailVerificationReturn-link',
  signUpEmailID: 'signUp-email-textfield',
  signUpFirstNameID: 'signUp-firstName-textfield',
  signUpLastNameID: 'signUp-lastName-textfield',
  signUpPhoneID: 'signUp-phone-textfield',
  signUpPasswordID: 'signUp-password-textfield',
  signUpConfirmPasswordID: 'signUp-confirmPassword-textfield',
  signUpConfirmButtonID: 'signUp-confirm-button',
  signUpReturnButtonID: 'signUp-return-button',
  signUpWelcomeID: 'signUp-welcome-title',
  signUpAgreeID: 'signUp-agreeToTerms-checkbox',
  deleteAccountButtonID: 'profile-deleteAccount-button',
  deleteAccountPasswordID: 'profile-deleteAccountPassword-textfield',
  firstNameFieldID: 'profile-firstName-textfield',
  lastNameFieldID: 'profile-lastName-textfield',
  emailFieldID: 'profile-email-textfield',
  currentPasswordFieldID: 'profile-currentPassword-textfield',
  newPasswordFieldID: 'profile-newPassword-textfield',
  confirmPasswordFieldID: 'profile-confirmPassword-textfield',
  birthdayDateFieldID: 'profile-birthday-selector',
  stateFieldID: 'profile-state-selector',
  phoneFieldID: 'profile-phone-textfield',
  saveButtonID: 'profile-save-button',
  textMessagesLabelID: 'profile-phoneMessages-label',
  textMessagesToggleID: 'profile-phoneMessages-selector',
  textNotificationsToggleID: 'profile-phoneStudyNotifications-selector',
  settingsNameID: 'profile-name-button',
  settingsEmailID: 'profile-email-button',
  settingsPasswordID: 'profile-password-button',
  settingsBirthdayID: 'profile-birthday-button',
  settingsStateID: 'profile-state-button',
  settingsUnitSystemID: 'profile-unitSystem-button',
  settingsBiologicalSexID: 'profile-biologicalSex-button',
  settingsPhoneID: 'profile-phone-button',
  settingsWearableID: 'profile-wearable-button',
  settingsPrivacyID: 'profile-privacy-button',
  settingsLogOutID: 'profile-logOut-button',
  settingsNameLabelID: 'profile-name-label',
  settingsEmailLabelID: 'profile-email-label',
  startStudyID: 'studies-startStudy-button',
  noStudiesID: 'studies-noStudies-label',
  studyCardID: 'studies-studyCard-button',
  studyFavoriteIconID: 'studies-studyCardFavorite-button',
  studyNameID: 'studies-studyName-title',
  studySummaryID: 'studies-studySummary-label',
  studyDescriptionID: 'studies-studyDescription-label',
  studyDurationID: 'studies-studyDuration-label',
  studyDaysLoggedID: 'studies-studyDaysLogged-label',
  studyStartDateID: 'studies-studyStartDate-label',
  studyEndDateID: 'studies-studyEndDate-label',
  settingsIconID: 'studies-settings-button',
  webviewExitID: 'webview-exit-button',
  resultsCompareID: 'studies-resultsCompare-graphic',
  compareChartID: 'studies-compareChart-graphic',
  compareChartTitleID: 'studies-compareChart-title',
  pluginImpactGaugeInfoID: 'plugin-impactGauge-infoButton',
  pluginImpactGaugeMetricTitleID: 'plugin-impactGauge-metricTitle',
  pluginImpactGaugeMetricDescriptionID: 'plugin-impactGauge-metricDescription',
  pluginImpactGaugeMetricUnitID: 'plugin-impactGauge-metricUnit',
  gaugeChartLabelID: 'gauge-chart-label',
  pluginCompareInfoID: 'plugin-compare-infoButton',
  qaGraphicID: 'studies-qa-graphic',
  pluginOverviewMoreInfoID: 'plugin-overview-infoButton',
  pluginOverviewFocusLabelID: 'plugin-overview-focusLabel',
  pluginOverviewFocusDescriptionID: 'plugin-overview-focusDescription',
  pluginOverviewFocusIconID: 'plugin-overview-focusIcon',
  pluginOverviewTrackingLabelID: 'plugin-overview-trackingLabel',
  pluginOverviewTrackingDescriptionID: 'plugin-overview-trackingDescription',
  pluginOverviewTrackingIconID: 'plugin-overview-trackingIcon',
  pluginOverviewTargetLabelID: 'plugin-overview-targetLabel',
  pluginOverviewTargetDescriptionID: 'plugin-overview-targetDescription',
  pluginOverviewTargetIconID: 'plugin-overview-targetIcon',
  pluginOverviewInterventionLabelID: 'plugin-overview-interventionLabel',
  pluginOverviewInterventionDescriptionID:
    'plugin-overview-interventionDescription',
  pluginOverviewInterventionIconID: 'plugin-overview-interventionIcon',
  pluginDataTrackerID: 'plugin-dataTracker-view',
  pluginDataTrackerMoreInfoID: 'plugin-dataTracker-infoButton',
  pluginDataTrackerTitleID: 'plugin-dataTracker-titleText',
  pluginRollingAverageID: 'plugin-rollingAverage-view',
  pluginRollingAverageMoreInfoID: 'plugin-rollingAverage-infoButton',
  pluginRollingAverageTitleID: 'plugin-rollingAverage-titleText',
  pluginRollingAverageLegendWithMedID: 'plugin-rollingAverage-withMedLegend',
  pluginRollingAverageLegendWithoutMedID:
    'plugin-rollingAverage-withoutMedLegend',
  pluginImpactProgressID: 'plugin-impactProgress-view',
  pluginImpactProgressTitleID: 'plugin-impactProgress-title',
  pluginImpactProgressDescriptionID: 'plugin-impactProgress-description',
  pluginImpactProgressMoreInfoID: 'plugin-impactProgress-infoButton',
  pluginDataDiaryID: 'plugin-dataDiary-view',
  pluginDataDiaryTitleID: 'plugin-dataDiary-title',
  pluginDataDiaryMoreInfoID: 'plugin-dataDiary-infoButton',
  pluginDownloadID: 'plugin-downloadableForms-view',
  pluginImageGalleryID: 'plugin-imageGallery-view',
  pluginGalleryModalExitID: 'plugin-galleryModal-exitButton',
  pluginNotesID: 'plugin-notes-view',
  notebookListID: 'notebook-list-view',
  headerBackIconID: 'header-back-icon',
  notificationTimeID: 'studies-notificationTimeSetting-button',
  notificationTimeSubmitID: 'studies-notificationTimeSubmit-button',
  restartStudyID: 'studies-restartStudy-button',
  deleteStudyID: 'studies-deleteStudy-button',
  withdrawStudyID: 'studies-withdrawStudy-button',
  withdrawnLabelID: 'studies-withdrawnStudy-label',
  genericCardID: 'studies-genericCard-graphic',
  welcomeLabelID: 'today-welcome-label',
  dayStreakID: 'today-dayStreak-label',
  getStartedID: 'signUp-getStarted-button',
  signatureFieldID: 'form-signature-field',
  signatureClearButtonID: 'form-signatureClear-button',
  formSubtitleButtonID: 'form-subtitle-button',
  uploadImageButtonID: 'form-upload-button',
  takeImageID: 'form-takeImage-button',
  googleFitButtonID: 'data-googleFit-button',
  healthConnectButtonID: 'data-healthConnect-button',
  fitbitButtonID: 'data-fitbit-button',
  ouraButtonID: 'data-oura-button',
  garminButtonID: 'data-garmin-button',
  myDataEllipsisID: 'data-ellipsis-button',
  deviceDataSyncID: 'data-synchronize-button'
};

export default elementIDs;
